import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import Header from 'components/common/Header';
import { initialState } from 'store/initialStateSlice';

const Main = lazy(() => import(/* webpackPrefetch: true */ 'components/views/main/Main'));
const NotFound = lazy(() => import('components/views/NotFound'));
const Login = lazy(() => import('components/views/Login'));
const VaDotSafetyIndex = lazy(() => import('components/views/VaDotSafetyIndex.js'));
const VaIntermodalIndex = lazy(() => import('components/views/VaIntermodalIndex.js'));
const SeattleMicro = lazy(() => import('components/views/SeattleMicro.js'));
// [hygen] Import views

export const ROUTE_PATHS = {
  LOGIN: '/login',
  DEFAULT: '/',
  NOT_FOUND: '404',
  VA_DOT_SAFETY_INDEX: '/safety',
  VA_INTERMODAL_INDEX: '/intermodal',
  SEATTLE_MICRO: '/seattlemicro',
  // [hygen] Add path routes
};

const routes = [
  {
    path: ROUTE_PATHS.DEFAULT,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <Main />
        </DefaultView>
      </ProtectedRoute>
    ),
    children: [
      // { path: '/', element: <Navigate to='/<your default view>' /> },
      // { path: ROUTE_PATHS.VA_DOT_SAFETY_INDEX, element: <VaDotSafetyIndex /> },
      // { path: ROUTE_PATHS.VA_INTERMODAL_INDEX, element: <VaIntermodalIndex /> },
      { path: ROUTE_PATHS.SEATTLE_MICRO, element: <SeattleMicro /> },
      // [hygen] Add routes
    ],
  },
  { path: ROUTE_PATHS.LOGIN, element: <Login /> },
  {
    path: ROUTE_PATHS.NOT_FOUND,
    element: (
      <DefaultView>
        <NotFound />
      </DefaultView>
    ),
  },
  { path: '*', element: <Navigate to={ROUTE_PATHS.NOT_FOUND} /> },
];

export default routes;

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth0();
  const accessToken = useSelector((state) => state.carto.credentials.accessToken);

  if (!initialState.oauth) {
    return children;
  }

  const noAuthenticated = !isLoading && !isAuthenticated && !accessToken;

  if (noAuthenticated) {
    return <Navigate to={ROUTE_PATHS.LOGIN} />;
  }

  return !!accessToken && children;
}

function DefaultView({ children }) {
  return (
    <>
      <Header />
      {children}
    </>
  );
}
